// eslint-disable-next-line
export const Regex = new RegExp(/^[\[0-9-\]NXZ\.\*]+$/);
